import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/onboarding')({
  component: OnboardingLayout,
})

function OnboardingLayout() {
  return <Outlet />
}